document.addEventListener('DOMContentLoaded', () => {
    // .embed-product というクラス名を持つすべての要素を取得
    const embedTargets = document.querySelectorAll('.embed-product');
  
    // 対象の要素が見つからない場合は処理を終了
    if (embedTargets.length === 0) {
      return;
    }
  
    // 価格を日本円形式（¥）でフォーマットするための関数
    const formatPrice = (price) => {
      // Shopifyから受け取る価格はセント単位（例: 1000円は 100000）なので100で割る
      const priceInYen = price / 100;
      return new Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency: 'JPY',
      }).format(priceInYen);
    };
  
    // 各要素に対して処理を実行
    embedTargets.forEach(targetElement => {
      // 要素内のテキストから角括弧 [] を取り除き、ハンドル名を取得
      const handle = targetElement.textContent.trim().replace(/[\[\]]/g, '');
  
      // ハンドル名が空の場合は処理をスキップ
      if (!handle) {
        targetElement.innerHTML = '<p>エラー: ハンドル名が指定されていません。</p>';
        return;
      }
  
      // ShopifyのStorefront API（.jsエンドポイント）を使って商品情報を取得
      fetch(`/products/${handle}.js`)
        .then(response => {
          if (!response.ok) {
            throw new Error('商品が見つかりませんでした。');
          }
          return response.json();
        })
        .then(product => {
          // 取得した商品情報を使ってHTMLを生成（クラス名に "original-" を追加）
          const productHTML = `
            <div class="original-embedded-product-card">
              <a href="${product.url}" class="original-embedded-product-image-link">
                ${
                  product.featured_image
                    ? `<img src="${product.featured_image}" alt="${product.title}" class="original-embedded-product-image">`
                    : '<div class="original-embedded-product-no-image">画像がありません</div>'
                }
              </a>
              <div class="original-embedded-product-info">
                <div class="original-embedded-product-title">
                  <a href="${product.url}">${product.title}</a>
                </div>
                <div class="original-embedded-product-price">${formatPrice(product.price)}</div>
                <a href="${product.url}" class="original-embedded-product-button">商品を詳しくみる</a>
              </div>
            </div>
          `;
          // 元の要素の中身を生成したHTMLで置き換える
          targetElement.innerHTML = productHTML;
        })
        .catch(error => {
          console.error('商品情報の取得に失敗しました:', error);
          targetElement.innerHTML = `<p>エラー: 「${handle}」という商品情報の読み込みに失敗しました。ハンドル名が正しいか確認してください。</p>`;
        });
    });
  });